import { useState } from 'react';
import { API } from '../../../../api/api';
import { URLS } from '../../../../api/urls';
import { Modal } from '../../../../components/Modal/Modal';
import { ALERT_TEXT } from '../../../../constants/content';
import { useAlert } from '../../../../context/Alert.context';
import { ModelDto } from '../../../../types/models.types';
import { ModelEdit } from '../../GadgetsPage.type';
import { ModelForm } from './ModelForm';

interface CreateGadgetModalProps {
  open: boolean;
  onClose: () => void;
  updateGadgetAfterCreateModel: (model: ModelEdit) => void;
  selectedModel: ModelDto;
}

export const CreateModelModal = ({
  open,
  onClose,
  updateGadgetAfterCreateModel,
  selectedModel,
}: CreateGadgetModalProps) => {
  const [loading, setLoading] = useState(false);
  const { showAlert } = useAlert();

  const createModel = (model: ModelEdit) => {
    setLoading(true);
    const formData = new FormData();
    formData.append('file', model.file);
    model.fileHero && formData.append('fileHero', model.fileHero);
    formData.append('slug', model.slug);
    formData.append('isPopularInMenu', model.isPopularInMenu ? 'true' : 'false');
    formData.append('menuPriority', String(model.menuPriority || 0));
    formData.append('nameEn', model.nameEn || '');
    formData.append('nameRu', model.nameRu || '');
    formData.append('namePl', model.namePl || '');
    formData.append('nameUk', model.nameUk || '');
    formData.append('faqPl', JSON.stringify(model.faqPl ?? []));
    formData.append('faqEn', JSON.stringify(model.faqEn ?? []));
    formData.append('faqUk', JSON.stringify(model.faqUk ?? []));
    formData.append('faqRu', JSON.stringify(model.faqRu ?? []));

    formData.append('seoDescriptionEn', model.seoDescriptionEn || '');
    formData.append('seoDescriptionRu', model.seoDescriptionRu || '');
    formData.append('seoDescriptionPl', model.seoDescriptionPl || '');
    formData.append('seoDescriptionUk', model.seoDescriptionUk || '');

    formData.append('subtitleEn', model.subtitleEn || '');
    formData.append('subtitleRu', model.subtitleRu || '');
    formData.append('subtitlePl', model.subtitlePl || '');
    formData.append('subtitleUk', model.subtitleUk || '');

    formData.append('seoTitleEn', model.seoTitleEn || '');
    formData.append('seoTitleRu', model.seoTitleRu || '');
    formData.append('seoTitlePl', model.seoTitlePl || '');
    formData.append('seoTitleUk', model.seoTitleUk || '');

    formData.append('seoTitleH1En', model.seoTitleH1En || '');
    formData.append('seoTitleH1Ru', model.seoTitleH1Ru || '');
    formData.append('seoTitleH1Pl', model.seoTitleH1Pl || '');
    formData.append('seoTitleH1Uk', model.seoTitleH1Uk || '');
    formData.append('services', JSON.stringify(model.services));
    selectedModel?.gadgetId &&
      formData.append('gadgetId', selectedModel.gadgetId);

    API.post(URLS.MODELS, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(({ data }) => {
        updateGadgetAfterCreateModel(data);
        onClose();
        showAlert({
          message: ALERT_TEXT.MODEL_CREATED_SUCCESS,
          severity: 'success',
        });
      })
      .catch((e) => showAlert({ message: e?.response?.data?.response ?? 'Failed to create model', severity: 'error' }))
      .finally(() => setLoading(false));
  };

  return (
    <Modal shouldPreventModal title="Add model" open={open} onClose={onClose}>
      <ModelForm
        gadgetSlug={selectedModel.gadgetSlug || ''}
        loading={loading}
        onSubmit={createModel}
        onCancel={onClose}
      />
    </Modal>
  );
};
